import { Command } from 'ckeditor5';
export const REMOVE_CONDITION_COMMAND = 'removeCondition';
/** Removes a condition's markers, leaving the text they wrapped in place. */
export class RemoveConditionCommand extends Command {
    execute(options) {
        const { markerName } = options;
        const { model } = this.editor;
        if (!model.markers.has(markerName)) {
            return;
        }
        model.change((writer) => {
            writer.removeMarker(markerName);
        });
    }
}
